module.exports = __webpack_public_path__ + "static/media/microwave.0d7a90e5.svg";